import { StoreProvider } from '@components';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { Layout } from './app/[brand]';
import './index.css';
import { store } from './store/store';

const createApp = () => {
  document
    .getElementById('prepare-env')
    ?.addEventListener('prepare-env-loaded', () => {
      const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
      );
      root.render(
        <React.StrictMode>
          <HashRouter>
            <StoreProvider store={store}>
              <Layout>
                <App />
              </Layout>
            </StoreProvider>
          </HashRouter>
        </React.StrictMode>
      );
    });
};

createApp();
